import { useCallback } from 'react';
import { Easing, useAnimatedStyle, useSharedValue, withTiming } from 'react-native-reanimated';

import { theme } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Gentle grow-on-touch shared by the glass navbar surfaces. A hold eases the
 * surface up to its full press scale; a quick tap only gets part way before
 * easing back, which still reads as a response without a visible jump.
 */
export const useNavbarPressScale = () => {
  //
  // ─── Shared Values ───────────────────────────────────────────────────

  const pressScaleSV = useSharedValue(1);

  // ─── Handlers ────────────────────────────────────────────────────────

  const handlePressIn = useCallback(() => {
    pressScaleSV.value = withTiming(PRESS_SCALE, PRESS_SCALE_IN_TIMING_CONFIG);
  }, [pressScaleSV]);

  const handlePressOut = useCallback(() => {
    pressScaleSV.value = withTiming(1, PRESS_SCALE_OUT_TIMING_CONFIG);
  }, [pressScaleSV]);

  // ─── Animated Styles ─────────────────────────────────────────────────

  const pressScaleAnimatedStyles = useAnimatedStyle(() => ({
    transform: [{ scale: pressScaleSV.value }],
  }));

  // ─────────────────────────────────────────────────────────────────────

  return { handlePressIn, handlePressOut, pressScaleAnimatedStyles };
};

// ─── Constants ───────────────────────────────────────────────────────────────

const PRESS_SCALE = 1.05;

// NOTE: Ease-in on the way up keeps a quick tap from producing a visible jump,
//       since the first few frames barely move.
const PRESS_SCALE_IN_TIMING_CONFIG = {
  duration: theme.transitions.long * 2,
  easing: Easing.inOut(Easing.sin),
};
const PRESS_SCALE_OUT_TIMING_CONFIG = {
  duration: theme.transitions.long,
  easing: Easing.out(Easing.sin),
};
